<template>
    <div style="padding-top: 41px;" v-loading.fullscreen.lock="isLoading" element-loading-text="数据正在加载中" >
        <div id="topFix">
            <topNav></topNav>
        </div>
        <miniNav></miniNav>
        <Header></Header>
        <SubNav></SubNav>
        <div class="pageWidth">
            <div class="crumbs bread">您的位置：<a href="/">拍卖首页</a> &gt; <a :href="'/brand'">拍卖机构</a> &gt;{{orgInfo.Name}}</div>
            <div class="top-hd">
                <span>{{orgInfo.Name}}</span><a href="/gongyue.php" target="_blank" alt="《中国文物艺术品拍卖企业自律公约》成员单位" title="《中国文物艺术品拍卖企业自律公约》成员单位" v-if="orgInfo.IsZhongpai > 0">
                    <img style="height:18px;" src="@/assets/imgs/Frame205@2x.png" alt="《中国文物艺术品拍卖企业自律公约》成员单位"></a>
            </div>
            <div class="fix">
            <div class="juh-left">
                <OrgNews :organName="orgInfo.SimpleName"></OrgNews>
                <!-- detail 由父级统一请求后下发：OrgSpecail 以前在自己的 mounted 里又打了一次
                     /v3/organ/other/info，同一个 organCode 的同一份数据被请求两次（加密接口还要各带一次
                     /v1/sequence，实际是 4 个请求）。数据留在父级，子组件只消费 props。 -->
                <OrgSpecail :isLogin="isLogin" :organName="orgInfo.SimpleName" :orgInfo="orgInfo" :t="t" :detail="dataJSON"></OrgSpecail>
            </div>
            <div class="juh-right">
                <OrgInfo :orgInfo="orgInfo"></OrgInfo>
                <OrgRecord :goodResultArt="goodResultArt" :isLogin="isLogin" :t="t"></OrgRecord>
            </div>
            </div>
        </div>
        <Contact :showFri="true" :orgEdit="true"></Contact>
        <Footer></Footer>
    </div>
</template>

<script>
import topNav from "@/components/oldCommon/topNav";
import miniNav from "@/components/oldCommon/miniNav";
import Header from "@/components/oldCommon/header";
import SubNav from "@/components/oldCommon/subNav";
import Contact from "@/views/brand/components/contact";
import Footer from "@/components/oldCommon/footer";
import OrgNews from "@/views/brand/components/OrgNews";
import OrgSpecail from "@/views/brand/components/OrgSpecail";
import OrgRecord from "@/views/brand/components/OrgRecord";
import OrgInfo from "@/views/brand/components/OrgInfo";
import {getOrgDetail,getOrgInfo} from "@/api/organ";
import {
    mapActions,mapGetters
} from 'vuex';
import {addRouter,postDetail} from "@/api/company";

export default {
    name: "org_detail",
    components:{
        topNav,
        miniNav,
        Header,
        SubNav,
        Contact,
        Footer,
        OrgNews,
        OrgSpecail,
        OrgRecord,
        OrgInfo,
    },
    data(){
        return{
            orgId:this.$route.params.id,
            meetingDetail:null,
            speLabel:[],
            dataJSON:{},
            goodResultArt:[],
            isLogin:0,
            orgInfo:{},
            isLoading:true,
            status:0,
            zoneList:[],
            t:0
        }
    },
    //服务端渲染
    asyncData({ store,route }) {
        let params = {
            organCode:route.params.id,
            only_meta:1
        }
        return store.dispatch("pageOrganDetail/getOrganMeta", [params, () => {}]);
    },
    mounted() {
        this.t=Date.now()
        this.getOrgInfo()
        window.scroll({ top: 0, left: 0 })
        // getOrgMeta({organCode:this.$route.params.id,only_meta:1}).then(res =>{
        //     console.log(res)
        // })
        //机构详情（/v3/organ/other/info）只依赖路由上的 organCode，与 meta 没有先后关系，
        //所以和 getOrganMeta 并行发，不再挂在它的回调里：
        //  1) 「拍卖预展/拍卖结果」整块不用再等 meta 的两段式加密请求；
        //  2) getOrganMeta 的回调 fn 只在 .then 里调用（见 store/actions/pageOrganDetail.js），
        //     meta 一旦 reject，挂在回调里的东西永远不会执行 —— 以前 OrgSpecail 自己也发一次请求，
        //     所以这块还能显示；改成父级统一取数之后，这里必须解耦，否则 meta 挂了整块就空了。
        this.getOrgDetailFun();
        if (!this.getIsLoadIng){
            let parmas = {
                organCode:this.$route.params.id,
                only_meta:1
            }
            this.getOrganMeta([parmas,()=>{
                this.filteData();
            }])
        }else{
            this.filteData();
        }
        if(this.getCookie('_at_pt_0_')){
            this.isLogin = 1
        }
    },
    computed:{
        ...mapGetters({
            getIsLoadIng: "pageOrganDetail/getIsLoadIng",
            getData: "pageOrganDetail/getData",
        }),
    },
    methods:{
        ...mapActions({
            getOrganMeta:"pageOrganDetail/getOrganMeta"
        }),
        getZoneList(name){
            addRouter().then((res) => {
                if(res.code == 0){
                    this.zoneList = res.data.list
                    let a = this.zoneList.filter(e => {
                        return e == name
                    })
                    // if(a.length){
                    //     location.href = '/'+name
                    // }
                    postDetail({
                        web_name: name
                    }).then(resCode => {
                        if(resCode.code==0){
                            location.href = '/'+name
                        }
                        // this.$set(this.id,res.data.organ_id)
                    })
                }
            })
        },
        getCookie:function (name) {
            var arr;
            var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            if(document.cookie.match(reg)) {
                arr = document.cookie.match(reg);
                return arr[2];
            }else {
                return null;
            }
        },
        filteData(){
            let data = this.$store.state["pageOrganDetail"]["data"]
            console.log(data,'orgmeta')
            document.title = data.meta ? data.meta.title :'';
            let head = document.getElementsByTagName('head');
            this.isLoading = false
            if(!document.querySelector('meta[name=description]')){
                let meta = document.createElement('meta');
                meta.name = 'description';
                meta.content = data.meta ? data.meta.description : '';
                head[0].appendChild(meta)
            }else{
                document.querySelector('meta[name=description]').setAttribute('content',data.meta ? data.meta.description : '')
            }
        },
        getOrgDetailFun(){
            let parmas = {
                organCode:this.$route.params.id
                // organCode:this.orgId
            }
            getOrgDetail(parmas).then((res) => {
                if(res.code == 0){
                    let json = res.data
                    this.dataJSON = json
                    this.goodResultArt = json.good_result_art
                    // this.isLogin = json.isLogin
                    this.isLoading = false
                    this.status = json.status
                }
            })
        },
        getOrgInfo(){
            let parmas = {
                // organCode:this.orgId,
                organCode:this.$route.params.id,
                language:'zh-CN'
                // organCode:this.orgId
            }
            getOrgInfo(parmas).then((res) => {
                if(res.code == 0){
                    let json = res.data
                    this.orgInfo = json
                    this.getZoneList(json.ZoneName)
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.bread{padding:15px 0;font-family: SimSun;border-bottom: 2px solid #1988c0;color:#333;line-height: normal;font-size: 12px;}
.bread a{color:#000;}
.bread a:hover{color:#0099CC;text-decoration: underline;}
.top-hd{
    height: 70px;
    margin-top: 20px;
    line-height: 65px;
    font-size: 30px;
    font-family: 微软雅黑;
    background: rgb(232, 232, 232);
    span{padding:0px 10px 0px 30px;}
}
.juh-left{width:600px;float:left;}
.juh-right{width:300px;float:right;}
</style>